import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import type { ElementTheme } from "app/pages/sales-intelligence/types/styles";
import { FlexRowFlexEnd } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import ResultsTable from "./common/ResultsTable/ResultsTable";

export const tableCellTheme: Required<ElementTheme> = {
    colors: {
        main: colorsPalettes.carbon[400],
        secondary: colorsPalettes.carbon[250],
        hover: colorsPalettes.blue[400],
        disabled: colorsPalettes.carbon[200],
    },
    icon: {
        main: colorsPalettes.carbon[200],
        hover: colorsPalettes.blue[400],
        disabled: colorsPalettes.carbon[100],
    },
};

export const contentWrapperBaseStyles = css`
    border-radius: 8px;
    background-color: ${colorsPalettes.carbon[0]};
`;

export const tableHeaderCellStyles = css`
    ${setFontVariant("primaryItem", colorsPalettes.carbon[400])};

    font-size: 13px;
`;

export const transitionStyles = (property: CSSTransition["transitionProperty"]) => css`
    transition: ${property} 250ms ease-in-out;
`;

export const StyledSubTitle = styled.p`
    ${setFontVariant("subtitle1")};
    line-height: 24px;
    font-size: 18px;

    margin-bottom: 8px;
`;

export const StyledListItem = styled.li`
    ${setFontVariant("body1")};

    padding-left: 8px;
`;

export const StyledList = styled.ul`
    margin-left: 20px;
    margin-bottom: 0;
    list-style-type: disc;
`;

export const StyledResultsTable = styled(ResultsTable)`
    padding: 0 24px;
`;

export const StyledResultsTableWrapper = styled.div`
    margin-bottom: 8px;
`;

export const StyledSavedSearchResultsTable = styled(StyledResultsTable)`
    .MiniFlexTable-column:not(:first-of-type) {
        width: 20%;
    }

    .MiniFlexTable-column:last-of-type {
        width: 35%;
    }
`;

export const StyledResultsContainer = styled.div`
    ${contentWrapperBaseStyles};
`;

export const StyledContentFooter = styled(FlexRowFlexEnd)`
    padding: 8px 16px;
    border-top: 1px solid ${colorsPalettes.blue[100]};
    box-sizing: border-box;
`;

export const StyledButtonsContainer = styled(FlexRowFlexEnd)`
    column-gap: 8px;
`;

export const StyledCardButtonContent = styled.div`
    line-height: normal;
`;

export const StyledListItemSeparatorWrapper = styled.div`
    padding-top: 11px;
    * {
        color: ${colorsPalettes.carbon[250]};
    }
`;
